module.exports = __webpack_public_path__ + "static/img/cg@2x.bb91fad.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/cg@2x.png
// module id = +RUT
// module chunks = 1